import { Icon } from '../../Icon';
import { messageStrings } from '../../../constants/strings';
import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard';

type Props = {
  text: string;
};

export function AiAnswerCopyButton({ text }: Props) {
  const { status, copy } = useCopyToClipboard();

  return (
    <button
      type="button"
      onClick={() => void copy(text)}
      aria-label={messageStrings.aiCopyAnswer}
      title={
        status === 'success'
          ? messageStrings.aiCopyAnswerSuccess
          : status === 'error'
            ? messageStrings.aiCopyAnswerError
            : messageStrings.aiCopyAnswer
      }
      className="shrink-0 rounded-lg p-1.5 text-neutral-400 transition-colors hover:bg-white/80 hover:text-blue-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/40"
    >
      {status === 'success' ? (
        <Icon icon="check" className="h-4 w-4 text-green-600" />
      ) : status === 'error' ? (
        <span className="text-[10px] font-medium text-red-500">!</span>
      ) : (
        <Icon icon="copy" className="h-4 w-4" />
      )}
      <span className="sr-only" aria-live="polite">
        {status === 'success'
          ? messageStrings.aiCopyAnswerSuccess
          : status === 'error'
            ? messageStrings.aiCopyAnswerError
            : ''}
      </span>
    </button>
  );
}
